import { Box, Grid, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import {
  PlanoButton,
  PlanoDropDownMenu,
  PlanoLoaderModal,
  PlanoModal,
  PlanoTypography,
} from "../../Common";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../Hooks/apiCalls";
import { isDevelopment } from "../../Hooks/constants";
import { IoStorefront } from "react-icons/io5";
import { toast } from "react-toastify";
import {
  openSideBarModal,
  setLoc,
  setSearchTextDropdown,
  setStoreCodeRedirect,
} from "../../Store/Common/commonStore";
import PlanoSearchInput from "../../Common/PlanoSearchInput";
import { FaArrowRight } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa6";
import { debounce } from "lodash";

const HeaderForGallery = ({
  dataForVersions = [],
  handleVersionChange = () => {},
  versionValue = "",
  dataForDepatment = [],
  departmentValue = "all",
  handleChangeForDepartment = () => {},
  setLoader,
  handleSelectStore = () => {},
  results = [],
  setResults = () => {},
  searchText = "",
  setSearchText = () => {},
  planoData = [],
  handleReset,
}) => {
  const { store } = useParams();
  const storeNameText =
    useSelector((state) => state.dashboard.storeNameText) || "";
  const Location = useSelector((state) => state.common.loc);

  const fetchData = async (searchTerm) => {
    if (searchTerm === "") {
      setResults([]);
      setLoader(false);
      return;
    }
    let { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }searchstore?search_text=${searchTerm}`,
      true
    );
    if (data.status === "success") {
      setResults(data.data);
    } else {
      toast.error("No Store Found");
    }
    setLoader(false);
  };

  const debounced = React.useCallback(debounce(fetchData, 500), []);
  const handleSearch = (e) => {
    let { value } = e.target;
    setSearchText(value);
    if (value.length >= 4) {
      debounced(e.target.value, 1000);
      setLoader(true);
    }
  };

  useEffect(() => {
    if (searchText === "") {
      setResults([]);
      setLoader(false);
    }
  }, [searchText]);

  return (
    <>
      <Box className={styles.headerBody}>
        <Box className={styles.headerSelectBox}>
          <PlanoTypography className={styles.headerText}>
            Plano 2.0 Gallery
          </PlanoTypography>
        </Box>
        <Box className={styles.headerSelectBox2}>
          <PlanoTypography className={styles.headerText}>
            Plano Score :{" "}
            <span className={styles.planoScore}>
              {planoData?.plano_score || 0}
            </span>
          </PlanoTypography>
          <PlanoTypography className={styles.headerText}>
            Bay Execution :{" "}
            <span className={styles.planoScore}>{`${
              planoData?.total_images || 0
            }  / ${planoData?.uploded_images || 0}`}</span>
          </PlanoTypography>
        </Box>

        <Box className={styles.headerSelectBox3}>
          {/* <PlanoTypography className={styles.headerText}>
          Location : {store} {storeNameText}
        </PlanoTypography> */}
          <PlanoSearchInput
            value={searchText}
            onChange={handleSearch}
            data={results}
            onClick={handleSelectStore}
            onClickNo={handleReset}
          />
        </Box>
      </Box>
      <Box className={styles.headerBody2}>
        <Box className={styles.headerSelectBoxDropDown}>
          <PlanoDropDownMenu
            value={versionValue}
            handleChange={handleVersionChange}
            menuOptions={dataForVersions}
            disabled={Location === ""}>
            <IoStorefront className={styles.headerSelectLogo} />
            Versions / Cycles
          </PlanoDropDownMenu>
        </Box>

        <Box className={styles.headerSelectBoxDropDown}>
          <PlanoDropDownMenu
            value={dataForDepatment.length === 0 ? "" : departmentValue}
            handleChange={handleChangeForDepartment}
            menuOptions={dataForDepatment}
            disabled={Location === ""}>
            <IoStorefront className={styles.headerSelectLogo} />
            Department
          </PlanoDropDownMenu>
        </Box>
      </Box>
    </>
  );
};
const PhotoBox = ({
  src,
  text,
  index,
  uploadDate,
  versionDateText,
  departmentname,
  displayData,
  pageCount,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const [currentImage, setCurrentImage] = useState(index);

  const handleForward = () => {
    setCurrentImage(currentImage + 1);
  };
  const handleBackward = () => {
    setCurrentImage(currentImage - 1);
  };

  const imageDataShown = displayData[currentImage];

  useEffect(() => {
    if (openModal) {
      setCurrentImage(index);
    }
  }, [openModal]);
  return (
    <>
      <Grid
        item
        lg={2.4}
        xs={6}
        md={3}
        sm={4}
        key={index}
        className={styles.photoBoxBody}
        onClick={handleOpen}>
        <PlanoTypography className={styles.photoBodyUploadText}>
          {uploadDate}
        </PlanoTypography>
        <img
          src={src}
          className={styles.photoBodyImage}
          alt={text}
          loading="lazy"
        />

        <PlanoTypography className={styles.photoBodyText}>
          <span className={styles.photoBodyBayText}>{text}</span>
          <span
            style={{
              textAlign: "left",
            }}>
            {departmentname}
          </span>
        </PlanoTypography>
      </Grid>
      <PlanoModal
        open={openModal}
        setOpen={setOpenModal}
        size={"xl"}
        showHeader={true}
        showFooter={false}
        title={
          <PlanoTypography className={styles.photoBodyModalTextBody}>
            <PlanoTypography className={styles.photoBodyModalText}>
              <PlanoTypography>
                Version Date :
                <span className={styles.photoBodyModalText3}>
                  {imageDataShown?.version_date}
                </span>
              </PlanoTypography>
              <PlanoTypography>
                Bay :
                <span className={styles.photoBodyModalText3}>
                  {imageDataShown?.bay_no}
                </span>
              </PlanoTypography>
              <PlanoTypography>
                Department :
                <span className={styles.photoBodyModalText3}>
                  {imageDataShown?.department_name}
                </span>
              </PlanoTypography>
            </PlanoTypography>
            <PlanoTypography className={styles.photoBodyModalText2}>
              Upload Date : {imageDataShown?.upload_date}
            </PlanoTypography>
          </PlanoTypography>
        }>
        <Box className={styles.photoBodyModalBody}>
          <PlanoButton
            className={styles.photoBodyModalButton}
            mainfunction={handleBackward}
            dissable={currentImage === 0}>
            <FaArrowLeft />
          </PlanoButton>
          <img
            src={imageDataShown?.image_url}
            alt={imageDataShown?.image_name}
            className={styles.heightForModalImage}
          />
          <PlanoButton
            className={styles.photoBodyModalButton}
            dissable={currentImage === displayData.length - 1}
            mainfunction={handleForward}>
            <FaArrowRight />
          </PlanoButton>
        </Box>
      </PlanoModal>
    </>
  );
};

const Gallery = () => {
  const { store } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [photoData, setPhotoData] = useState([]);
  const [versionsAndPlanoArray, setVersionsAndPlanoArray] = useState([]);
  const [versionsArray, setVersionsArray] = useState([]);
  const [versionDateText, setVersionDateText] = useState("");
  const [departmentsArray, setDepartmentsArray] = useState([]);
  const [departmentSelect, setDepartmentSelect] = useState("All");
  const [planoData, setPlanoData] = useState([]);
  const [bayExecutionData, setBayExecutionData] = useState([]);
  const [date, setDate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState([]);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(photoData?.length / itemsPerPage);
  const storeCodeText = useSelector((state) => state.common.storeCode);
  const getSearchText = useSelector((state) => state.common.searchTextGallery);
  const searchTextDropdown = useSelector(
    (state) => state.common.searchTextDropdown
  );

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const displayItems = photoData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePlanoData = (cycleString) => {
    // Finding in the versionsAndPlanoArray where the first element matches the cycleString
    const result = versionsAndPlanoArray.find(
      (versionArrayAndExe) => versionArrayAndExe[0] === cycleString
    );
    // Return the object at index 1 if found, otherwise return null
    return result ? setPlanoData(result[1]) : setPlanoData([]);
  };

  const handleVersionChange = (e) => {
    setVersionDateText(e.target.value);
    let { value } = e.target;
    const splitValue = value?.split(": ");
    handlePlanoData(e.target.value);
    setPage(1);
    setDate(splitValue[1]);
    getGalleryData(storeCodeText, splitValue[1], departmentSelect);
  };

  const handleDepartmentChange = (e) => {
    setPage(1);
    setDepartmentSelect(e.target.value);
    getGalleryData(storeCodeText, date, e.target.value);
  };
  const getPlanoVersions = async (locData) => {
    if (locData === "" || locData === null || locData === undefined) {
      locData = storeCodeText;
    }
    setLoader(true);
    let { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getplanoversions?loc=${locData}`,
      true
    );

    if (data.status === "success") {
      setLoader(false);
      setVersionsAndPlanoArray(data.data[0]);
      const extractingVersionsArray = data?.data[0]?.map(
        (versionsData) => versionsData[0]
      ); //extracting just the cycles text : with date and setting to array of versions
      //Doing this for plano drop down component
      setVersionsArray(extractingVersionsArray);
      setDepartmentsArray(data.data[1]);
      const splitData = data.data[0][0][0].split(": ");
      setDate(splitData[1]); // extracting just the date and setting date for api call
      setVersionDateText(data.data[0][0][0]); // setting version date with cycle
      setPlanoData(data.data[0][0][1]); // setting data of plano execution acc. to verison
      setBayExecutionData(data.data[2]);
      // handlePlanoData(bayExecutionData, data.data[0][0]);
      getGalleryData(locData, splitData[1], "All");
    } else {
      setLoader(false);
      setVersionsArray([]);
      setPhotoData([]);
      setPlanoData([]);
      dispatch(setLoc(""));
      dispatch(setStoreCodeRedirect(""));
      setBayExecutionData([]);
      setSearchText("");
      toast.error(data.message);
    }
  };
  const getGalleryData = async (
    locData,
    version_date,
    departmentSelectValue
  ) => {
    if (locData === "" || locData === null || locData === undefined) {
      locData = storeCodeText;
    }
    if (locData === "") {
      // toast.error("Search For a location");
      return;
    }
    if (version_date === "") {
      toast.error("Select Version Date To Proceed");
      return;
    }
    setLoader(true);
    let { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getgallery?loc=${locData}&version_date=${version_date}&department_name=${encodeURIComponent(
        departmentSelectValue
      )}`,
      true
    );

    if (data.status === "success") {
      setLoader(false);
      setPhotoData(data.data);
    } else {
      setLoader(false);
      setPhotoData([]);
      setDate("");
      toast.error(data.message);
    }
  };

  const handleReset = () => {
    setSearchText("");
  };
  const handleSelectStore = (data) => {
    setDepartmentSelect("All");
    setPhotoData([]);
    setResults([]);
    setDepartmentsArray([]);
    setPage(1);
    setPlanoData([]);
    setBayExecutionData([]);
    setSearchText(data.loc + " " + data.loc_name);
    dispatch(setSearchTextDropdown(data.loc + " " + data.loc_name));
    dispatch(setStoreCodeRedirect(data.loc));
    dispatch(setLoc(data.loc));
    getPlanoVersions(data.loc);
    // navigate(`/gallery/${data.loc}`);
  };

  useEffect(() => {
    dispatch(openSideBarModal(false));
    if (storeCodeText !== "" && !loader) {
      const value = searchTextDropdown.split(" ");
      if (Number(value[0]) === storeCodeText) {
        setSearchText(searchTextDropdown);
      }
      getPlanoVersions(storeCodeText);
      return;
    }
  }, [storeCodeText]);

  return (
    <Box className={styles.body}>
      <HeaderForGallery
        handleVersionChange={handleVersionChange}
        dataForVersions={versionsArray}
        versionValue={versionDateText}
        dataForDepatment={departmentsArray}
        departmentValue={departmentSelect}
        handleChangeForDepartment={handleDepartmentChange}
        setLoader={setSearchLoader}
        handleSelectStore={handleSelectStore}
        results={results}
        setResults={setResults}
        setSearchText={setSearchText}
        searchText={searchText}
        planoData={planoData}
        handleReset={handleReset}
      />
      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
        {displayItems?.map((elem, index) => (
          <PhotoBox
            src={elem.image_url}
            text={elem.bay_no}
            index={index}
            uploadDate={elem.upload_date}
            versionDateText={date}
            departmentname={elem.department_name}
            displayData={displayItems}
            pageCount={pageCount}
          />
        ))}
      </Grid>
      {displayItems.length !== 0 ? (
        <Box display="flex" justifyContent="center" marginTop={4}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      ) : (
        <PlanoTypography
          css={{
            textAlign: "center",
            fontSize: "20px",
            marginTop: "20vh",
          }}>
          No Images Uploaded
        </PlanoTypography>
      )}
      <PlanoLoaderModal
        open={loader || searchLoader}
        text={
          searchLoader ? "Searching for Locations" : "Fetching Gallery Details"
        }
      />
    </Box>
  );
};

export default Gallery;
